import React from 'react';
import '../css/custom-spinner.css'
import spin from '../img/spin.gif';

    function CustomSpinner(props) {
        return (
            <div className="custom-spinner-backdrop">
                <div className="custom-spinner-containter">
                    <div className="custom-spinner-content text-center">
                        <img alt="Loading" src={spin}/>
                        <p>{props.message}</p>
                    </div>
                </div>
            </div>
            );
    };
export default CustomSpinner;


/** WEBPACK FOOTER **
 ** ./src/components/CustomSpinner.js
 **/